<template>
  <div
    :class="{
      'inner-notification--loading': loading,
    }"
    class="inner-notification"
  >
    <span class="inner-notification__message">
      {{ notification.message }}
    </span>
    <button
      v-if="notification.buttonLabel"
      ref="button"
      type="button"
      class="inner-notification__button"
      @click="notification.buttonAction"
    >
      {{ notification.buttonLabel }}
      <div class="inner-notification__loading-spinner" />
    </button>
  </div>
</template>

<script>
export default {
  name: 'NotificationItem',
  props: {
    notification: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.inner-notification {
  $notification: &;

  &__message {
    margin-right: $sp-xs;
  }
  &__button {
    position: relative;
    color: inherit;
    border: 0;
    padding: 0;
    background: transparent;
    font: inherit;
    box-shadow: inset 0 -2px 0 0 currentColor;
    cursor: pointer;
    outline: 0;
    transition: color 0.15s ease-in-out;

    #{$notification}--loading & {
      pointer-events: none;
      color: transparent;
    }
  }

  &__loading-spinner {
    $size: 20px;

    display: none;
    position: absolute;
    top: calc(50% - calc(#{$size} / 2));
    left: calc(50% - calc(#{$size} / 2));
    width: $size;
    height: $size;
    border: 2px solid $white;
    border-right-color: transparent;
    border-bottom-color: transparent;
    border-radius: 50%;
    opacity: 0;
    transition: opacity 0.15s ease-in-out;
    animation: spin 0.5s infinite linear;

    #{$notification}--loading & {
      display: block;
      opacity: 1;
    }
  }
}
</style>
